/**
 * Authenticated fetch wrapper
 * Automatically adds Authorization header to all API requests
 */

import { getValidAccessToken, refreshAccessToken } from './authTokens';
import { clearSession } from './authSession';

const API_BASE_URL = window.location.hostname === 'localhost'
  ? 'http://172.235.245.13/api'
  : '/api';

export const authFetch = async (endpoint: string, options: RequestInit = {}): Promise<Response> => {
  const token = await getValidAccessToken();

  const buildHeaders = (authToken: string | null) => {
    const headers: Record<string, string> = {
      ...((options.headers as Record<string, string>) || {})
    };

    // Only set Content-Type if body is NOT FormData
    // FormData needs the browser to auto-set Content-Type with boundary
    if (!(options.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    return headers;
  };

  const url = `${API_BASE_URL}${endpoint}`;
  const requestOptions = {
    ...options,
    headers: buildHeaders(token)
  };

  let response = await fetch(url, requestOptions);

  if (response.status === 401) {
    const refreshedToken = await refreshAccessToken();
    if (refreshedToken) {
      const retryResponse = await fetch(url, {
        ...options,
        headers: buildHeaders(refreshedToken)
      });
      if (retryResponse.status !== 401) {
        return retryResponse;
      }
    }

    clearSession('Your session expired. Please sign in again.');
    throw new Error('Session expired');
  }

  return response;
};

